// extracted by mini-css-extract-plugin
export default {"section":"styles_section__3Tjsh","grid":"styles_grid__n4jKj","loadMoreWrapper":"styles_loadMoreWrapper__CPd8Y"};